// Core Module
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule }               from '@angular/platform-browser/animations';
import { BrowserModule, Title }                  from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule }                      from '@angular/common/http';
import { AppRoutingModule }                      from './app-routing.module';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule }                              from '@angular/core';
import { FormsModule, ReactiveFormsModule }      from '@angular/forms';

// Main Component
import { AppComponent }                    from './app.component';
import { HeaderComponent }                 from './components/header/header.component';
import { SidebarComponent }                from './components/sidebar/sidebar.component';
import { SidebarRightComponent }           from './components/sidebar-right/sidebar-right.component';
import { TopMenuComponent }                from './components/top-menu/top-menu.component';
import { PanelComponent }                  from './components/panel/panel.component';
import { FloatSubMenuComponent }           from './components/float-sub-menu/float-sub-menu.component';
import { ThemePanelComponent }             from './components/theme-panel/theme-panel.component';

// Component Module
import { NgScrollbarModule, NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

// Pages
import { HomePage }          from './pages/home/home';

// Error
import { ErrorPage }          from './pages/error/error';
import { LogInV1Page } from './pages/logIn/loginV1';
import { SpinnerModule } from './modulos/spinner/spinner.module';
import { NuevoRegistroProveedorDialogComponent } from './dialogs/proveedores/nuevo-registro-dialog/nuevo-registro-proveedor-dialog.component';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditarRegistroProveedorDialogComponent } from './dialogs/proveedores/editar-registro-dialog/editar-registro-proveedor-dialog.component';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';
import { VisualizarRegistroProveedorDialogComponent } from './dialogs/proveedores/visualizar-registro-dialog/visualizar-registro-proveedor-dialog.component';
import { AprobarRegistroProveedorDialogComponent } from './dialogs/proveedores/aprobar-registro-dialog/aprobar-registro-proveedor-dialog.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CambiarEstatusDialogComponent } from './dialogs/cambiar-estatus-dialog/cambiar-estatus-dialog.component';
import { DescargarFiltrosDialogComponent } from './dialogs/descargar-filtros-dialog/descargar-filtros-dialog.component';
import { SpinnerNuevoComponent } from './components/spinner-nuevo/spinner-nuevo.component';
import { DescargarPendienteAltaDialogComponent } from './dialogs/descargar-pendiente-alta/descargar-pendiente-alta-dialog.component';
import { NuevaCompraDialogComponent } from './dialogs/compras/nueva-compra-dialog/nueva-compra-dialog.component';
import { AprobarCompraDialogComponent } from './dialogs/compras/aprobar-compra-dialog/aprobar-compra-dialog.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { CustomDateParserFormatter } from './formatter/custom-date-parser-formatter';
import { FormatearMilesDirective } from './formatter/number-directive';
import { SubirArchivoDialogComponent } from './dialogs/subir-archivo-dialog/subir-archivo-dialog.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { PreviewPdfDialogComponent } from './dialogs/compras/preview-pdf-dialog/preview-pdf-dialog.component';
import { ValidarProveedorDialogComponent } from './dialogs/proveedores/validar-proveedor/validar-proveedor-dialog.component';
import { AltaBancoProveedorDialogComponent } from './dialogs/proveedores/alta-banco-proveedor/alta-banco-proveedor-dialog.component';
import { CambiarPerfilDialogComponent } from './dialogs/cambiar-perfil/cambiar-perfil-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { RestriccionesConceptosDialogComponent } from './dialogs/restricciones-conceptos-dialog/restricciones-conceptos-dialog.component';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    FormatearMilesDirective,
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    PanelComponent,
    FloatSubMenuComponent,
    ThemePanelComponent,
    SpinnerNuevoComponent,
    LogInV1Page,
    HomePage,
    
    AprobarRegistroProveedorDialogComponent,
    NuevoRegistroProveedorDialogComponent,
    VisualizarRegistroProveedorDialogComponent,
    EditarRegistroProveedorDialogComponent,
    ValidarProveedorDialogComponent,
    AltaBancoProveedorDialogComponent,
    CambiarEstatusDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    RestriccionesConceptosDialogComponent,
    DescargarFiltrosDialogComponent,
    DescargarPendienteAltaDialogComponent,
    NuevaCompraDialogComponent,
    AprobarCompraDialogComponent,
    ConfirmDialogComponent,
    CambiarPerfilDialogComponent,
    ErrorPage,
    PreviewPdfDialogComponent
  ],
  imports: [
    MatExpansionModule,
    AppRoutingModule,
    MatInputModule,
    BrowserAnimationsModule,
    BrowserModule,
    NgbDatepickerModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    SpinnerModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    NgxDatatableModule,
    MatSelectModule,
  ],
  providers: [ 
     { provide: LOCALE_ID, useValue: 'es-MX' },
      { provide: DEFAULT_CURRENCY_CODE, useValue: 'MXN' },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    Title, {
		  provide: NG_SCROLLBAR_OPTIONS,
		  useValue: {
			  visibility: 'hover'
		  }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [ AppComponent ]
})

export class AppModule {
  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        var title = 'TWX | ' + this.route.snapshot.firstChild.data['title'];
        this.titleService.setTitle(title);
      }
    });
  }
}
